import { useStoreState } from 'easy-peasy';

export const useGlobalFilters = () => {
  // TODO: look into returning ["all"] if all sites are included in view selector instead of huge array
  const globalFilters = useStoreState((state) => state.analyze.getGlobalFiltersWithSiteIds);

  return globalFilters;
};
